import { BehaviorSubject, Subject } from "rxjs"
import { CoordinatorService } from "./coordinator.service"
import { AiLlmResponse } from "./ai-llm-response"



export class Ai$ {
    response$ = new BehaviorSubject<any>(null)

    isReady = false
    worker: any
    // isOn = true
    isOn = false
    lastSimilarityList$ = new Subject()

    suggestMap: any
    suggestMeta: any

    constructor(private coords: CoordinatorService) {

    }

    onStart() {
        // this.coords.worker$.ai.response$
        //     .subscribe({
        //         next: x => this._workerResponse(x.payload),
        //         error: e => console.log(e)
        //     })

    }


    processResponse(params: any) {
        return new AiLlmResponse(this.coords, params)
    }

    start() {
        this.coords.isAI = true
    }

    async prompt(txt: string) {
        const resp = await this.coords.firebase$
            .callFunction("prompt", {
                prompt: txt
            })
        if (resp === "ERROR") return

        console.log("AI RESPONSE", resp.data)
    }

    private _workerResponse(params: any) {
        switch (params.action) {
            case "test":
                return this._test(params)
        }

    }


    private _test(params: any) {
        // const r = Object.assign(params.payload, {
        //     action: params.action,
        //     itmMap: new Map(this.selectedLs.map(x => [x.id, x]))
        // })

        this.response$.next(params)
    }

    post(action: string, payload: any) {
        // this.coords.worker$.ai.directPost({
        //     action: action,
        //     payload: payload
        // })
    }

    // addMeta(tp: string, data: any) {
    //     if (!this.suggestMeta)
    //         this.suggestMeta = {}
    //     this.suggestMeta[tp] = data
    // }

    // handler(params) {
    //     // console.log("HHHH", params)
    //     if (params.ready)
    //         this.isReady = true
    //     params.similarityLs && this.lastSimilarityList$
    //         .next(params.similarityLs)

    //     if (params.aiSuggest)
    //         this.coords.collection$.aiSuggest$.next(params)
    // }
}
